<div class="bok-container">

    <div class="bok-panel-container">
        <div class="form">
            <h1>Biuro obsługi Klienta</h1>
            <div class="description">
                Jeżeli nie masz dostępu do skrzynki e-mail,
                <br/> to skontaktuj się z naszym Biurem obsługi Klienta
            </div>

            <h2>609-111-114</h2>
            <div>
                <a class="link" href="mailto:serwis@tekom.pl">serwis&#64;tekom.pl</a>
            </div>
            <div>
                <a class="link" href="https://tekom.pl">tekom.pl</a>
            </div>



            <!-- wróć -->
            <div class="action">
                <emq-button styleClass="btn-blue btn-go-back" (click)="onNavigateToLogin()">Wróć</emq-button>
            </div>

        </div>
    </div>


</div>
